import React from "react";
import PropTypes from "prop-types";
import { ListGroup, ListGroupItem } from "reactstrap";
import { BUSINESS_RULES_CATEGORIES, BUSINESS_RULES_DEFINITIONS } from "../../../../models/businessRule";
import { NeoSideMenu, NeoBadge } from "../../../../components/Common";

/**
 * BusinessRulesSidebar
 * Sidebar com as categorias de regras de negócio utilizando o NeoSideMenu do Neo Design System.
 */
const BusinessRulesSidebar = ({ activeCategoryId, onSelectCategory, loading }) => {
    // Contar regras por categoria
    const countByCategory = {};
    BUSINESS_RULES_CATEGORIES.forEach(cat => {
        countByCategory[cat.id] = BUSINESS_RULES_DEFINITIONS.filter(r => r.category === cat.id).length;
    });

    return (
        <NeoSideMenu
            title="Regras de Negócio"
            subtitle={`${BUSINESS_RULES_DEFINITIONS.length} regras configuráveis`}
            icon="mdi-shield-check-outline"
            loading={loading}
        >
            <ListGroup flush>
                {BUSINESS_RULES_CATEGORIES.map((cat) => {
                    const isActive = activeCategoryId === cat.id;
                    const total = countByCategory[cat.id];

                    return (
                        <div className="px-2 mb-1.5" key={cat.id}>
                            <ListGroupItem
                                tag="button"
                                action
                                onClick={() => onSelectCategory(cat.id)}
                                className={`border-0 py-3 px-3 d-flex align-items-center justify-content-between select-none neo-side-menu-item ${isActive ? "neo-side-menu-item--active" : ""}`}
                            >
                                <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                    <div className="side-menu-icon-wrapper me-3 flex-shrink-0">
                                        <i className={`mdi ${cat.icon} font-size-16`} />
                                    </div>
                                    <div className="text-start overflow-hidden">
                                        <h6 className="mb-0 fw-bold text-truncate font-size-13 side-menu-title">
                                            {cat.id}
                                        </h6>
                                        <span className="text-muted small font-size-11 d-block text-truncate">
                                            {cat.description}
                                        </span>
                                    </div>
                                </div>

                                <div className="flex-shrink-0 ms-2">
                                    <NeoBadge color={isActive ? "accent" : "muted"}>
                                        {total} regra{total !== 1 ? 's' : ''}
                                    </NeoBadge>
                                </div>
                            </ListGroupItem>
                        </div>
                    );
                })}
            </ListGroup>
        </NeoSideMenu>
    );
};

BusinessRulesSidebar.propTypes = {
    activeCategoryId: PropTypes.string,
    onSelectCategory: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

export default BusinessRulesSidebar;
